module.exports = __webpack_public_path__ + "static/004-dde752600573c05b31781d57509cd747.jpg";